import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { OnePageCheckoutTabState } from "@sunSource/Store/Data/NewOnePageCheckout/OnePageCheckoutDataState";
import { Dispatch } from "react";

type OnePageCheckoutTabAction = {
    type: "Pages/OnePageCheckout/TabState";
    onePageCheckoutTabData: OnePageCheckoutTabState;
};

type HandlerType = (props: {
    dispatch: Dispatch<OnePageCheckoutTabAction>;
    parameter: OnePageCheckoutTabState;
}) => void;

export const OnePageCheckoutTabData: HandlerType = props => {
    props.dispatch({
        type: "Pages/OnePageCheckout/TabState",
        onePageCheckoutTabData: props.parameter, // Ensure payload contains the expected structure
    });
};

export const chain = [OnePageCheckoutTabData];

const SetOnePageTabData = createHandlerChainRunner(chain, "SetOnePageTabData");
export default SetOnePageTabData;
